// this is an autogenerated file from App/Account/Content/Settings/Content/TreatmentAutomations/insert-event-mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_TreatmentAutomations($object: events_events_insert_input!) {
  insert_events_events_one(object: $object) {
    id
  }
}

`